import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type CheckableTag from './checkable-tag.vue'

export interface CheckableTagItem {
  label: string
  value: string
}

export const checkableTagProps = buildProps({
  value: {
    type: definePropType<string[]>(Array),
    default: () => [],
  },
  options: {
    type: definePropType<CheckableTagItem[]>(Array),
    default: () => [],
  },
  // 字段名
  fieldNames: {
    type: Object,
    default: () => ({
      label: 'label',
      value: 'value',
    }),
  },
  // 是否启用添加
  enableAdd: {
    type: Boolean,
    default: true,
  },
  // 最大可选标签数
  maxChecked: {
    type: Number,
    default: 0,
  },
  // 是否自动选择新增标签
  addAutoSelect: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: '请输入',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // 删除规则（全部可删/全部不可删/除前N个外可删）
  deleteRule: {
    type: String,
    values: ['all', 'none', 'exceptFirstN'],
    default: 'none',
  },
  // 当删除规则为exceptFirstN时，保留的标签数量
  exceptCount: {
    type: Number,
    default: 0,
  },
  // 标签大小
  size: {
    type: String,
    values: ['small', 'middle', 'large'],
    default: 'small',
  },
  addTagText: {
    type: String,
    default: '新增',
  },
  inputWidth: {
    type: Number,
    default: 120,
  },
  tagMaxWidth: {
    type: Number,
    default: 0,
  },
  emptyText: {
    type: String,
    default: '暂无数据',
  },
  tagGap: {
    type: Number,
    default: 8,
  },
  maxAddableTags: {
    type: Number,
    default: 0,
  },
  disabledAddTag: {
    type: Boolean,
    default: false,
  },
  disabledCloseTag: {
    type: Boolean,
    default: false,
  },
  // 选择模式（multiple多选/single单选）
  selectionMode: {
    type: String,
    values: ['multiple', 'single'],
    default: 'multiple',
  },
} as const)

// props
export type CheckableTagProps = ExtractPropTypes<typeof checkableTagProps>

// instance
export type CheckableTagInstance = InstanceType<typeof CheckableTag>
